import { Injectable, inject } from '@angular/core';
import { Api } from '../api/api';
import {
  adminPlatformSettingsControllerGetSettingsV1,
  adminPlatformSettingsControllerUpdateSocialLinksV1,
} from '../api/functions';
import type { PlatformSettingsResponseAdminDto, UpdateSocialLinksDto } from '../api/models';

/**
 * Platform Settings API Service
 * Wrapper around generated API functions for platform settings management
 */
@Injectable({ providedIn: 'root' })
export class PlatformSettingsApiService {
  private readonly api = inject(Api);

  /**
   * Get current platform settings
   */
  async getSettings(): Promise<PlatformSettingsResponseAdminDto> {
    return this.api.invoke(adminPlatformSettingsControllerGetSettingsV1, {});
  }

  /**
   * Update social media links
   */
  async updateSocialLinks(data: UpdateSocialLinksDto): Promise<PlatformSettingsResponseAdminDto> {
    return this.api.invoke(adminPlatformSettingsControllerUpdateSocialLinksV1, {
      body: data,
    });
  }
}
